import * as yup from 'yup';

export const filterSectionsFormValidationSchema = yup.object().shape({});
